"use strict";

const lightStickTutorialZh = require("../assets/locales/zh/lightstickTutorial.json");
const lightStickTutorialEn = require("../assets/locales/en/lightstickTutorial.json");
const generalZh = require("../assets/locales/zh/general.json");
const generalEn = require("../assets/locales/en/general.json");
module.exports.loadLightStickTutorialPageRes = i18n => {
  i18n.addResourceBundle("en", "lightStickTutorial", lightStickTutorialEn);
  i18n.addResourceBundle("zh", "lightStickTutorial", lightStickTutorialZh);
};
module.exports.loadGeneralRes = i18n => {
  i18n.addResourceBundle("en", "general", generalEn);
  i18n.addResourceBundle("zh", "general", generalZh);
};